export default __webpack_public_path__ + "static/media/office_ceiling.28ffbbfd.jpg";